import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';
import globals from '../../../globals/communityGlobals';
import SubRowTreatmentTimeSlotsDataTable from './SubRowTreatmentTimeSlotsDataTable';
import { lowerFirstLetter } from '../../../utils/helpers';

const locale = globals.getArea('audit');
const eventTypeLocale = globals.getArea('eventType');
const eventTypeChangesLocale = globals.getArea('eventTypeChanges');
export const treatmentTableSettings = data => {
  return {
    name: <Typography variant="h3">{locale.getMsg('auditTrail')}</Typography>,
    columns: [
      {
        name: 'eventType',
        label: locale.getMsg('auditEventType'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
          customBodyRender: value => {
            return eventTypeLocale.getMsg(lowerFirstLetter(value));
          },
        },
      },
      {
        name: 'userLogin',
        label: locale.getMsg('user'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
        },
      },
      {
        name: 'createdDate',
        label: locale.getMsg('date'),
        options: {
          sort: false,
          customBodyRender: value => moment(value).format(globals.dateFormats.short),
        },
      },
      {
        name: 'createdDate',
        label: locale.getMsg('time'),
        options: {
          sort: false,
          customBodyRender: value => moment(value).format(globals.timeFormats.hours24),
        },
      },
      {
        name: 'eventType',
        label: locale.getMsg('changes'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
          customBodyRender: value => {
            return eventTypeChangesLocale.getMsg(lowerFirstLetter(`${value}Changes`));
          },
        },
      },
      {
        name: 'originalValue',
        label: locale.getMsg('originalValues'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
        },
      },
      {
        name: 'newValue',
        label: locale.getMsg('newValues'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
        },
      },
    ],
    options: {
      responsive: 'standard',
      selectableRows: 'none',
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      pagination: false,
      expandableRowsHeader: false,
      expandableRows: true,
      isRowExpandable: dataIndex => {
        return data && data[dataIndex].eventType === 'TreatmentTimeUpdatedEvent';
      },
      renderExpandableRow: (rowData, rowMeta) => {
        return (
          <SubRowTreatmentTimeSlotsDataTable
            timeSlotDetails={data[rowMeta.dataIndex].timeSlotDetails}
            rowData={rowData}
          />
        );
      },
    },
  };
};
